import React from "react";

interface NameFilterProps {
    name: {
        firstName: string;
        lastName: string;
    };
    onChange: any;
    onEnterPress?: () => void;
}

export const NameFilter: React.FC<NameFilterProps> = ({ name, onChange, onEnterPress }) => {
    return (
        <div className="space-y-3">
            <input
                type="text"
                name="firstName"
                id="firstName"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                placeholder="By Full Name"
                onChange={onChange}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === 'Enter' && onEnterPress) {
                        onEnterPress();
                    }
                }}
                value={name.firstName}
            />
            <input
                type="text"
                name="lastName"
                id="lastName"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                placeholder="By Last Name"
                onChange={onChange}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === 'Enter' && onEnterPress) {
                        onEnterPress();
                    }
                }}
                value={name.lastName}
            />
        </div>
    );
};